import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    setAcceptedSoftCheck,
    setAcceptedIncomeCheck,
    requestSoftCheck,
    setSoftCheckError,
} from './softCheckActions';

import SoftCheck from './components/SoftCheck';

function SoftCheckContainer(props) {
    return (
        <SoftCheck
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            consents={props.consents}
            applicantId={props.applicantId}
            applicant={props.applicant}
            applicationId={props.applicationId}
            application={props.application}
            customer={props.customer}
            setAcceptedIncomeCheck={props.setAcceptedIncomeCheck}
            setAcceptedSoftCheck={props.setAcceptedSoftCheck}
            requestSoftCheck={props.requestSoftCheck}
            decision={props.decision}
            maxLendAmount={props.maxLendAmount}
            isPending={props.isPending}
            isError={props.isError}
            errorMessage={props.errorMessage}
            softCheckCompleted={props.softCheckCompleted}
        />
    );
}

const mapStateToProps = state => ({
    consents: state.softCheckReducer.consents,
    applicantId: state.customerReducer.uid,
    applicant: state.applicantDetailsReducer.applicant,
    customer: state.customerReducer,
    applicationId: state.applicationIdReducer,
    application: state.quickQuoteReducer,
    decision: state.softCheckReducer.decision,
    maxLendAmount: state.softCheckReducer.maxLendAmount,
    isPending: state.softCheckReducer.isPending,
    errorMessage: state.softCheckReducer.errorMessage,
    isError: state.softCheckReducer.isError,
});

const mapDispatchToProps = dispatch => ({
    setAcceptedIncomeCheck: (event) => {
        dispatch(setAcceptedIncomeCheck(event));
    },
    setAcceptedSoftCheck: (event) => {
        dispatch(setAcceptedSoftCheck(event));
    },
    requestSoftCheck: (params) => {
        dispatch(requestSoftCheck(params)).catch((error) => {
            dispatch(setSoftCheckError(error));
        });
    },
});

SoftCheckContainer.defaultProps = {
    errorMessage: '',
};

SoftCheckContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    consents: PropTypes.object.isRequired,
    applicantId: PropTypes.string.isRequired,
    applicant: PropTypes.object.isRequired,
    applicationId: PropTypes.string.isRequired,
    application: PropTypes.object.isRequired,
    customer: PropTypes.object.isRequired,
    setAcceptedIncomeCheck: PropTypes.func.isRequired,
    setAcceptedSoftCheck: PropTypes.func.isRequired,
    requestSoftCheck: PropTypes.func.isRequired,
    decision: PropTypes.string.isRequired,
    maxLendAmount: PropTypes.object.isRequired,
    isPending: PropTypes.bool.isRequired,
    isError: PropTypes.bool.isRequired,
    softCheckCompleted: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SoftCheckContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SoftCheck/SoftCheckContainer.js